angular.module('mtic.components.modules').service('PanelStateService', function() {
  var expanded_resources = {};
  var showAgenda = true;
  var active_agenda;
  return {
    agendaShowing: function() {
      return showAgenda;
    },
    setAgendaShowing: function(val) {
      showAgenda = val;
    },
    setActiveAgenda: function(val) {
      active_agenda = val;
    },
    getActiveAgenda: function() {
      return active_agenda;
    },
    setResourceExpanded: function(slug, is_expanded) {
      expanded_resources[slug] = is_expanded;
    },
    getResourceExpanded: function(slug) {
      return expanded_resources[slug];
    }
  }
})
